import prefs from '@/controllers/preferences'

export const settingsName = 'stt_settings'
// TODO: have presets:
// 1. Quiet environment
// 2. Noisy environment
// Can make it more sensitive for quiet environment
export const defaults = {
    positiveSpeechThreshold: 0.82,
    negativeSpeechThreshold: 0.65,
    redemptionFrames: 50,
    minSpeechFrames: 4,
    whisperMinNoSpeechProb: 0.09
};

// set defaults
// FIXME: this doesn't work
// async function init() {
//     await prefs.get_or_set(settingsName, defaults);
// }

// init();

export async function get() {
    await prefs.get_or_set(settingsName, defaults);
    return await prefs.get(settingsName)
}
// export async function get_val(name : string) {
//     const settings = await prefs.get(settingsName);
//     //console.log(settings)
//     //return settings
//     return settings[name] ? settings[name] : defaults[name]

//     // if (isNaN(settings[name])) {
//     //     return defaults[name];
//     // } else {
//     //     return settings[name];
//     // }
// }
// window.get_val = get_val
// window.defaults = defaults

export async function reset() { await prefs.set(settingsName, defaults) }
export async function change(change) {
    for (const k of Object.keys(change)) {
        if (!change[k]) change[k] = defaults[k];
        //console.log(k);
    }

    const newSettings = {...await get(), ...change};
    await prefs.set(settingsName, newSettings);
    return newSettings
}